import React from 'react'
import Tabs from 'antd/lib/tabs'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import SearchForm from './SearchForm'
import Sort from './Sort'
import View from './View'

class Search extends React.Component {
  rehydrate = false
  constructor(props) {
    super(props)
    
    // set the initial state
    this.state = {
      type: window.gwSearch.activeTab,
      forms: {
        commercial: {
          searchIsDirty: false,
        },
        residential: {
          searchIsDirty: false,
        },
        offmarket: {
          searchIsDirty: false,
        },
        sales: {
          searchIsDirty: false ,
        }
      },
    }
    
    
    // update the state from the uri
    const params = this.props.uriParams


    if (params.type) this.state.type = params.type

    // take a look at what fields we have and set the defaults
    Object.keys(this.props.formParams).forEach(formType => {
      Object.keys(this.props.formParams[formType].fields).forEach(fieldName => {
        const field = this.props.formParams[formType].fields[fieldName]
        //this is where to search for sales or rental properties
        const paramVal = params.type && params.type === formType && params[fieldName] ? this.transformUriComponents(params[fieldName], field.type) : null
        
        
        // set a default for each field
        this.state.forms[formType][fieldName] = paramVal === null
          ? 'default' in field ? field.default : ''
          : paramVal
        // defines whether we need to rehydrate or not
        if (paramVal === null && !this.rehydrate) this.rehydrate = true
        
      })
    })

    // set as false to not auto-filter off-market links
    if(this.state.type === 'offmarket') this.rehydrate = false;
    if (this.rehydrate) this.state.forms[this.state.type].searchIsDirty = true
    
  }

  
  componentDidMount() {
    if (this.rehydrate) setTimeout(() => this.handleSearchSubmit(this.state.type), 100)
  }

  onTabChange = tab => {
    this.setState({
      ...this.state,
      type: tab,
    })
    this.handleSearchSubmit(tab)
  }

  handleSetSearchState = type => (state, cb) => {
    // update the search label
    this.setState({
      ...this.state,
      forms: {
        ...this.state.forms,
        [type]: {
          ...this.state.forms[type],
          ...state,
        },
      }
    }, cb)
  }

  handleSearchSubmit = (type) => {
    const updateType = type || this.state.type
    const search = {
      ...this.state.forms[updateType],
      type: updateType,
    }
    
    // update the parent
    this.props.onSearch(search)
  }

  transformUriComponents(component, type) {
    const mapToInt = val => val.map(i => parseInt(i, 10))
    const types = {
      input: val => val,
      select: val => val,
      range: mapToInt,
      checkbox: val => val === 'true',
    }
    return type in types ? types[type](component) : component
  }

  renderSearchForms = () => {
    if (this.props.tabs.length === 1) {
      const tab = this.props.tabs[0]
      return (
        <div className="gw-search__type">
          <div className="gw-search__type-inner">
            <SearchForm fields={this.props.formParams[tab].fields} strings={this.props.strings} setSearchState={this.handleSetSearchState(tab)} onSubmit={this.handleSearchSubmit} searchState={this.state.forms[tab]} />
          </div>
        </div>
      )
    }
    const tabs = this.props.tabs.map(tab => {
      return (
        <Tabs.TabPane tab={this.props.formParams[tab].label} key={tab}>
          <SearchForm fields={this.props.formParams[tab].fields} strings={this.props.strings} setSearchState={this.handleSetSearchState(tab)} onSubmit={this.handleSearchSubmit} searchState={this.state.forms[tab]} />
        </Tabs.TabPane>
      )
    })
    return (
      <div className="gw-search__type">
        <div className="gw-search__type-inner">
          <Tabs defaultActiveKey={this.state.type} onChange={this.onTabChange} animated={false}>
            {tabs}
          </Tabs>
        </div>
      </div>
    )
  }

  render() {
    

    const viewSwitcher = this.props.results.length ? (
      <Col md={12} lg={8} className="gw-search__view gw-search__bar-item">
        <View strings={this.props.strings} view={this.props.resultsView} onViewChange={this.props.onViewChange} />
      </Col>
    ) : null
    const searchForms = this.props.view !== 'sort-only' ? this.renderSearchForms() : null
    const resultCount = this.props.view !== 'sort-only' ? (
      <Col sm={24} lg={8} className="gw-search__result-count gw-search__bar-item">
        {!this.state.forms[this.state.type].searchIsDirty ? <div className="h2">{this.props.strings.all_results}</div> :
        <div className="h2">{this.props.results.length} {this.props.strings.results}</div>}
      </Col>
    ) : null
    const searchDesc = this.props.searchDesc ? (<p className="h5" dangerouslySetInnerHTML={{__html: this.props.searchDesc}} />) : null
    const searchTitle = (
      <div className="gw-search__title">
        <h1>{this.props.searchTitle}</h1>
        {searchDesc}
      </div>
    )
    return (
      <div className="gw-search clear--after">
        {searchTitle}
        {searchForms}
        <div className="gw-search__bar">
          <Row type="flex">
            {resultCount}
            <Col md={12} lg={8} className="gw-search__sort gw-search__bar-item">
              <Sort strings={this.props.strings} sortBy={this.props.sortBy} onSort={this.props.onSort} extraSortOptions={this.props.extraSortOptions} />
            </Col>
            {viewSwitcher}
          </Row>
        </div>
      </div>
    )
  }
}

export default Search


// WEBPACK FOOTER //
// ./src/components/search/Search.js